import React from 'react'
import {Route,Redirect} from 'react-router-dom';
import auth from './Auth';

function ProtectedRoute ({component: Component, ...rest}) {
    return (
      <Route {...rest} render={(props) => auth.isValid===true ? <Component {...props} />: <Redirect to='/login' />}
      />
    )
  }
export default ProtectedRoute;